module.exports = __webpack_public_path__ + "img/cases-brand-suning--lazyload-24.72c84960.jpg";